import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { IoCreate, IoTrash } from 'react-icons/io5'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, Grupo, Parceiro, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { ModalMarcaGrupo } from '../Modal/modalMarcaGrupo'
import { useSelector } from 'react-redux'
import { createTheme, ThemeProvider } from '@mui/material'
import { selectUser } from '../Redux/userSlice'
import { Link, useNavigate } from 'react-router-dom'
import { GrupoService } from '../../Pages/Grupo/GrupoService'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { ToolTips } from '../ToolTips/tooltips'
import { Input } from '@mui/icons-material'
import moment from 'moment'
import { Tooltip } from 'react-tooltip'
import { Funcoes } from '../../Utils/Funcoes'
import { FaTrashAlt } from 'react-icons/fa'
import { RiEdit2Fill } from 'react-icons/ri'
import { ParceiroService } from '../../Pages/Parceiros/ParceiroService'

type Props = {
    parceiro: Parceiro[],
    handleUpdateParceiroList: () => void
}

type VisibilityState = Record<string, boolean>

interface RowData {
    id: number,
    razao: string,
    nome_fantasia: string,
    nome_cidade: string,
    celular: string,
    email: string,
    cnpj_cpf: string
}

export const GridParceiros = React.memo(({ parceiro, handleUpdateParceiroList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_parceiros")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_parceiros") || '')
                : {
                    acao: true,
                    razao: true,
                    nome_fantasia: true,
                    nome_cidade: true,
                    celular: true,
                    email: true,
                    cnpj_cpf: true
                }
        )
    }, [])

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_parceiros")

    let json: any = {
        acao: true,
        razao: true,
        nome_fantasia: true,
        nome_cidade: true,
        celular: true,
        email: true,

    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_parceiros") || '')
    }
    */

    /*
    useEffect(() => {
    
            if (xJson) {
    
                if (json) {
                    const newColumnVisibility: VisibilityState = { ...columnVisibility }
                    newColumnVisibility.acao = json.acao
                    newColumnVisibility.razao = json.razao
                    newColumnVisibility.nome_fantasia = json.nome_fantasia
                    newColumnVisibility.nome_cidade = json.nome_cidade
                    newColumnVisibility.celular = json.celular
                    newColumnVisibility.email = json.email
            }
        }
    
    }, [])
    */

    const [descricao, setDescricao] = useState("")
    const [idParceiro, setIdParceiro] = useState(0)

    const [idExcluir, setIdExcluir] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [parceiros, setParceiros] = useState<Parceiro[]>([])
    const [nomeParceiros, setNomeParceiros] = useState("")

    let user = useSelector(state => selectUser(state))


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {  
        setParceiros(parceiro)
    }, [parceiro])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_parceiros", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await ParceiroService.Delete(idExcluir, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Parceiro excluído com sucesso`)

                handleUpdateParceiroList()

                //setParceiros(await ParceiroService.Filter('', '', ''))
                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                // setModalShow(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir o parceiro. Por favor, tente novamente`)
        }

    }, [idExcluir])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_parceiro")
        inputElement?.focus()
    }

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeParceiros("")
        }
        
    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeParceiros("")
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- SEM USO --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (e.key === "Enter" || e.key === "NumpadEnter") {
            // Prevenir a ação padrão do Enter
            e.preventDefault()
        }
    }

    const handleReset = () => {
        setIdParceiro(0)
        setDescricao('')
    }

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaParceirosEdit = (id: number) => {
        navigate(`/parceiros/edit/${id}`)
    }

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const colunas = useMemo<MRT_ColumnDef<Parceiro>[]>(
        () => [

            {
                accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: true, size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    const navegar = () => {
                        navegarTelaParceirosEdit(rowData.id)
                    }

                    const handleExcluirClick = () => {

                        const timerExcluir = setTimeout(() => {
                            setIdExcluir(rowData.id)
                            setNomeParceiros(rowData.razao)
                            setModalShow(true)
    
                            let divPerfil = document.getElementById('div-perfil') as HTMLDivElement
    
                            if (divPerfil) {
                                divPerfil.classList.add('hidden')
                            }
    
                            let menuFiltro = document.getElementById("divMenuFiltroParceiros") as HTMLDivElement
                            let menuInputs = document.getElementById("divInputsParceiros") as HTMLDivElement
    
                            if (menuFiltro) {
    
                                menuInputs.classList.add("invisible")
    
                                const timer = setTimeout(() => {
                                    menuFiltro.classList.remove("max-h-[390px]")
                                    menuFiltro.classList.add("max-h-[0px]")
                                    Inputfocus()
                                    clearTimeout(timer)
                                }, 100)
                            }

                            clearTimeout(timerExcluir)
                        }, 0);

                        

                    }

                    return (
                        <div className={`flex justify-start w-full`}>

                            <button
                                onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500`}>
                                <RiEdit2Fill size="20px" />

                                <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                    <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`} >
                                <FaTrashAlt size="18px" />

                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed"  >
                                    <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                                </Tooltip>
                            </button>

                        </div>
                    )
                }
            },

            {
                accessorKey: 'razao', visibleInShowHideMenu: true, header: 'Razão Social / Nome', size: Math.round(window.innerWidth * 0.2), muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },
                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.razao ? rowData.razao : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'nome_fantasia', visibleInShowHideMenu: true, header: 'Nome Fantasia / Apelido', size: Math.round(window.innerWidth * 0.2), muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },
                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.nome_fantasia ? rowData.nome_fantasia : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'cnpj_cpf', visibleInShowHideMenu: true, header: 'CPF / CNPJ', size: Math.round(window.innerWidth * 0.2), muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },
                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.cnpj_cpf ? Funcoes.FormatDoc(rowData.cnpj_cpf) : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'nome_cidade', visibleInShowHideMenu: true, header: 'Cidade', size: Math.round(window.innerWidth * 0.1), muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },
                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.nome_cidade ? rowData.nome_cidade : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'celular', visibleInShowHideMenu: true, header: 'Celular', size: Math.round(window.innerWidth * 0.1), muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },
                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.celular ? Funcoes.FormatCelular(rowData.celular) : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'email', visibleInShowHideMenu: true, header: 'E-mail', size: Math.round(window.innerWidth * 0.1), muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },
                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.email ? rowData.email : <span className={`text-red-400`}>N/D</span>}</span>)

                }
            },

        ], []
    )


    const table = useMaterialReactTable({
        columns: colunas,
        data: parceiros,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir o parceiro - ${nomeParceiros || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>
    )

})